import EditIcon from "../../../assets/images/icons/edit-secondary-outlined.svg";
import LogoutIcon from "../../../assets/images/icons/logout-secondary-color.svg";
import GalleryIcon from "../../../assets/images/icons/gallery.svg";
import FormIcon from "../../../assets/images/icons/document-text.svg";
import StoreIcon from "../../../assets/images/icons/shop.svg";

export const profileMenuItems = [
  {
    title: "خدمات",
    items: [
      {
        name: "فرم ها",
        icon: FormIcon,
        link: "/forms",
      },

      {
        name: "گزارش تصویری",
        icon: GalleryIcon,
        link: "/gallery",
      },
      {
        name: "مراکز طرف قرارداد",
        icon: StoreIcon,
        link: "/contractingStores",
        linkNewTab: true,
      },
    ],
  },
  {
    title: "کاربر",
    items: [
      {
        name: "ویرایش اطلاعات",
        icon: EditIcon,
        link: "/user/update",
      },
      {
        name: "خروج از حساب کاربری",
        icon: LogoutIcon,
        link: "",
        action: "logOut",
      },
    ],
  },
];
